<template>
  <div class="goodCard">
    <div
      style="position: absolute; right: 6px; top: 13px; z-index: 1"
      v-if="
        commoditySpuVo &&
        commoditySpuVo.tagNameList &&
        commoditySpuVo.tagNameList.length
      "
    >
      <span
        v-for="(itm, idx) in commoditySpuVo.tagNameList"
        :key="idx"
        size="mini"
        class="tag"
        type="danger"
        effect="dark"
      >
        {{ itm }}
      </span>
    </div>
    <el-image class="img" :fit="'contain'" :src="imgSrc" lazy> </el-image>
    <div class="goodName ellipsis-2">{{ goodName }}</div>
    <div class="goodPrice" v-if="isCorpWebsite">
      <good-price
        v-if="
          commoditySpuVo &&
          !commoditySpuVo.isSellingPriceExpire &&
          commoditySpuVo.sellingPrice &&
          commoditySpuVo.sellingPrice !== '0'
        "
        :price="commoditySpuVo.sellingPrice || 0"
        :losePrice="commoditySpuVo.originPrice || 0"
        :discountRate="commoditySpuVo.discountRate || 0"
      >
      </good-price>
      <span v-else>{{ $t("home.rfq") }}</span>
    </div>
    <div class="goodPrice" v-else>
      {{
        (commoditySpuVo && !commoditySpuVo.minPrice) ||
        (commoditySpuVo && commoditySpuVo.isSellingPriceExpire)
          ? $t("home.rfq")
          : "￥" + goodPrice
      }}
    </div>
  </div>
</template>

<script>
import GoodPrice from "@/components/good-price/goodPrice";
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { GoodPrice },
  data() {
    return {
      defaultImg: require("@/assets/img/bitmap.png"),
    };
  },
  computed: {
    isCorpWebsite() {
      return this.$store.state.user.corpUserInfo.customerId;
    },
    imgSrc() {
      return this.dataSource.commodityUrl || defaultImg;
    },
    goodName() {
      return this.dataSource.commodityName || "";
    },
    goodPrice() {
      return (+this.dataSource.commoditySpuVo.minPrice || 0).toFixed(2);
    },
    commoditySpuVo() {
      return this.dataSource.commoditySpuVo || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.goodCard {
  width: 190px;
  height: 280px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  position: relative;
  border-radius: 16px;
  .img {
    width: 174px;
    height: 174px;
    border-radius: 16px;
    border: 2px solid #f5f6fa;
  }
  .goodName {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.95px;
    text-align: left;
    color: #333;
    height: 44px;
    margin-top: 10px;
  }
  .goodPrice {
    font-family: Alibaba PuHuiTi;
    font-size: 18px;
    font-weight: 500;
    line-height: 24.7px;
    text-align: left;
    color: #e93037;
    margin-top: 10px;
  }
  .tag {
    padding: 4px 6px;
    border-radius: 24px;
    border: 1px solid #e93037;
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 600;
    line-height: 16.46px;
    text-align: center;
    color: #e93037;
    margin-right: 6px;
  }
}
</style>
